import { Box, Stack, Typography } from '@mui/material';
import useEditFreespin from '../../../../../hooks/site/bonus/useEditFreespin';
import FSBonusAdd from './FSBonusAdd';
import FSBonusList from './FSBonusList';
import useGetFsCampaign from '../../../../../hooks/site/useGetFsCampaign';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import ErrorBoundary from '../../../../../components/material-ui/error_boundary/ErrorBoundary';
import SubgroupSave from '../../../../../components/bonus/ui/SubgroupSave';
import InfoDialog from '../../../../../components/shared/InfoDialog';
import { useMemo, useState } from 'react';
import Card from '../../../../../components/material-ui/adaptive/Card';
import FSInfoString from '../../../freespin/ui/FSInfoString';
import { useTranslation } from 'react-i18next';
import { ENUM_BONUS_ID } from '../../../../../enums/MenuItems';

export default function FreeSpin({ groupId, group }) {
  const allCampaigns = useGetFsCampaign(groupId);
  const { t } = useTranslation();

  const {
    fsEnable,
    fsName,
    fsCampaigns,
    lockSetting,
    updateSubgroups,
    fsActivated,
    fsExpired,
    fsCurrency,
    bonusFreespin,
    changeFsCurrency,
    changeFsActivated,
    changeFsExpired,
    changeLockSetting,
    changeFsName,
    changeSubgroup,
    changeEnable,
    addNewCampaign,
    deleteCampaign,
    deleteBonus,
    onSave
  } = useEditFreespin(groupId);

  const [openInfoId, setOpenInfoId] = useState(null); // boolean || number || {value:"", type}
  const currentBonus = bonusFreespin.find((el) => el.id == openInfoId);
  const openInfoTitle = currentBonus?.name ? `${t('Bonus')}: "${currentBonus?.name || ''}"` : '';

  const openInfoJSX = useMemo(() => {
    const campaigns = currentBonus?.campaigns;

    if (openInfoId?.type == 'campaignId') {
      const campaignId = openInfoId.value;
      const company = allCampaigns?.find((el) => el.campaignId == campaignId);

      return (
        <Card>
          <FSInfoString
            isPictureGame
            isColumn
            key={campaignId}
            company={company}
            // maxDeposit={companyInfo.maxDeposit}
            // minDeposit={companyInfo.minDeposit}
          />
        </Card>
      );
    }

    if (!campaigns?.length) return;
    if (!allCampaigns.length) return;

    return (
      <Box key={openInfoId}>
        {/* <Typography variant="caption">{t('There are bonus campaigns')}</Typography> */}
        {currentBonus?.campaigns?.map((companyInfo) => {
          const campaignId = companyInfo.campaignId;
          const company = allCampaigns?.find((el) => el.campaignId == campaignId);

          if (!company) return <Typography variant="body2">{t('Company not found')}</Typography>;
          return (
            <Card>
              <FSInfoString
                isPictureGame
                isColumn
                key={campaignId}
                company={company}
                maxDeposit={companyInfo.maxDeposit}
                minDeposit={companyInfo.minDeposit}
              />
            </Card>
          );
        })}
      </Box>
    );
  }, [currentBonus, allCampaigns, openInfoId]);

  return (
    <>
      <Stack display={'flex'} flexDirection={'column'} gap={1} py={1}>
        <Stack display={'flex'} flexDirection={'row'} gap={2} justifyContent={'space-between'}>
          <CusCheckbox title="Enable" checked={fsEnable} onChange={changeEnable} />
        </Stack>

        <Stack gap={2}>
          <ErrorBoundary>
            <FSBonusAdd
              groupId={groupId}
              allCampaigns={allCampaigns}
              fsName={fsName}
              fsCurrency={fsCurrency}
              fsExpired={fsExpired}
              fsActivated={fsActivated}
              fsCampaigns={fsCampaigns}
              addNewCampaign={addNewCampaign}
              changeFsName={changeFsName}
              changeFsActivated={changeFsActivated}
              changeFsCurrency={changeFsCurrency}
              changeFsExpired={changeFsExpired}
              deleteCampaign={deleteCampaign}
              setOpenInfoId={setOpenInfoId}
            />
          </ErrorBoundary>
        </Stack>

        <SubgroupSave
          lockSetting={lockSetting}
          updateSubgroups={updateSubgroups}
          id={ENUM_BONUS_ID.freespin}
          isNodeGroup={!group?.game}
          onSave={onSave}
          changeSubgroup={changeSubgroup}
          changeLockSetting={changeLockSetting}
        />

        <ErrorBoundary>
          <Box mt={4} p={0} />
          <FSBonusList
            deleteBonus={deleteBonus}
            allBonuses={bonusFreespin}
            groupId={groupId}
            setOpenInfoId={setOpenInfoId}
          />
        </ErrorBoundary>
      </Stack>

      <InfoDialog
        open={!!openInfoId}
        onClose={() => setOpenInfoId(false)}
        title={openInfoTitle}
        infoJSX={openInfoJSX}
      />
    </>
  );
}
